<script>
  let {
    title,
    subtitle,
    features,
  } = $props();
</script>

<section class="border-b border-[#3a3a4a]">
  <div class="max-w-6xl mx-auto px-4 py-16">
    <div class="text-center mb-12">
      <p class="text-[#888890] text-xs uppercase tracking-widest mb-3">── FEATURES ──</p>
      <h2 class="text-2xl md:text-3xl font-bold text-[#e8e8ec] mb-4">
        {title}
      </h2>
      <p class="text-[#a0a0a8] max-w-2xl mx-auto text-sm leading-relaxed">
        {subtitle}
      </p>
    </div>

    <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
      {#each features as feature, i}
        <div class="p-5 border border-[#3a3a4a] bg-[#101018] hover:border-[#a855f7] transition-colors">
          <div class="text-[#7ec699] text-sm mb-2">
            <span class="text-[#888890]">{String(i + 1).padStart(2, '0')}.</span> {feature.title}
          </div>
          <p class="text-[#909098] text-sm leading-relaxed">
            {feature.description}
          </p>
        </div>
      {/each}
    </div>
  </div>
</section>
